/** Label, sublabel, corner switch, and eye icon when a maskable field is minimized. */
export const MASKABLE_FIELD_MINIMIZED_CLASS =
  "text-muted-foreground opacity-60";
